/* eslint-disable menti-react/filename-convention--jsx */
import React from 'react';
import { ErrorBoundary } from '@mentimeter/errors/ErrorBoundary';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';
import {
  CountdownProvider,
  PresentationActionsProvider,
  SlideActionsProvider,
} from '../data-mediation';
import { FullscreenProvider } from '../data-mediation/fullscreen';
import Results from './Results';
import { BlankScreenProvider } from './overlays/blank-screen';

export const InternalProviders = ({
  children,
  renderFallbackOnError = true,
}: {
  children: React.ReactNode;
  renderFallbackOnError?: boolean;
}) => {
  const t = useTranslations('presenting.sfinx.presentation_error_boundary');
  return (
    <ErrorBoundary
      feature="live"
      fallback={
        renderFallbackOnError ? (
          <Box
            alignItems="center"
            justifyContent="center"
            position="absolute"
            width="100%"
            height="100%"
          >
            <Text mt="3">{t('error_message')}</Text>
            <Button
              size="large"
              mt="1"
              onClick={() => window.location.reload()}
            >
              {t('reload_page_button')}
            </Button>
          </Box>
        ) : undefined
      }
    >
      <Results>
        <BlankScreenProvider>
          <CountdownProvider>
            <PresentationActionsProvider>
              <FullscreenProvider>
                <SlideActionsProvider>{children}</SlideActionsProvider>
              </FullscreenProvider>
            </PresentationActionsProvider>
          </CountdownProvider>
        </BlankScreenProvider>
      </Results>
    </ErrorBoundary>
  );
};
